import React from "react";
import { Grid, Stack, Typography } from "@mui/material";
import { TimePicker } from "@mui/x-date-pickers";

interface LabeledTimePickerProps {
  label: string;
  value: Date | null;
  onChange: (value: Date | null) => void;
  helperText?: string;
}

export const LabeledTimePicker: React.FC<LabeledTimePickerProps> = ({
  label,
  value,
  onChange,
  helperText,
}) => {
  return (
    <Grid item xs={12}>
      <Stack gap={1}>
        <TimePicker
          label={label}
          value={value}
          onChange={onChange}
          sx={{ width: "100%" }}
        />
        {helperText && (
          <Typography
            variant="inputLabel"
            sx={{ color: "var(--grey-600, #798397)", fontWeight: 400 }}
          >
            {helperText}
          </Typography>
        )}
      </Stack>
    </Grid>
  );
};

export default LabeledTimePicker;
